import { synapse } from '@ublique/platform'

export const initialStoreCollaborationFiltersState = {
  store: [],
  allRooms: [],
  selectedRooms: []
}

const initialState = {
  filters: initialStoreCollaborationFiltersState
}

export const storeCollaborationStore = synapse.store(initialState)

export const selectors = {
  getFilters: (state) => state.filters
}

export default {
  storeCollaboration: storeCollaborationStore
}
